import React from 'react';
import { navigation } from './navigationConfig';

interface MobileMenuProps {
  currentPath?: string;
  isOpen: boolean;
  onClose: () => void;
}

const MobileMenu: React.FC<MobileMenuProps> = ({
  currentPath = '/',
  isOpen,
  onClose,
}) => {
  const isActive = (href: string) => {
    if (href === '/') {
      return currentPath === '/';
    }
    return currentPath?.startsWith(href);
  };

  if (!isOpen) return null;

  return (
    <div className='md:hidden'>
      <div className='px-4 pt-4 pb-6 space-y-2 sm:px-6 bg-glory-blue-dark/95 backdrop-blur-lg border-t border-glory-gold/20'>
        {navigation.map(item => (
          <a
            key={item.name}
            href={item.href}
            className={`block px-4 py-3 text-lg font-semibold transition-colors duration-200 rounded-lg ${
              isActive(item.href)
                ? 'text-glory-gold bg-glory-gold/10'
                : 'text-white hover:text-glory-gold-light hover:bg-white/5'
            }`}
            onClick={onClose}
          >
            {item.name}
          </a>
        ))}

        {/* 移动端工具区 */}
        <div className='border-t border-glory-gold/20 pt-4 mt-4'>
          <div className='px-4 py-3 text-base text-gray-300'>
            最后更新:{' '}
            <span className='text-glory-gold-light font-medium'>
              {new Date().toLocaleDateString('zh-CN')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
